import { configureStore } from '@reduxjs/toolkit';
import { Provider as StoreProvider } from 'react-redux';

import { NODE_ENV } from '../../constants';
import { homeReducer } from '../slices/homeSlice';

export const store = configureStore({
  reducer: homeReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
  devTools: NODE_ENV === 'development',
});

export type HomeDispatch = typeof store.dispatch;
export type HomeGetState = typeof store.getState;

// Development access to store
if (NODE_ENV === 'development') {
  (window as any).homeStore = store;
}

export const HomeProvider = (props: Readonly<{ children: React.ReactNode }>) => (
  <StoreProvider store={store} {...props} />
);
